<template></template>
<script type="text/babel">
  import GoogleMapChildren from './GoogleMapChildren'
  export default {
    name: 'GoogleMapDrawingManager',
    extends: GoogleMapChildren,
    data() {
      return {
        item: null,
        overlays: [],
        selectedOverlay: null,
      }
    },
    methods: {
      init() {
        if (this.item == null) {
          this.item = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.POLYGON,
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_CENTER,
              drawingModes: ['polygon']
            }
          })
          this.item.setMap(this.$parent.getMap())


          if (this.initial) {
            this.initial.forEach((p) => {
              var p = new google.maps.Polygon({
                path: p,
              })

              p.setMap(this.$parent.getMap())

              this.overlays.push(p)

              google.maps.event.addListener(p, 'click', () => {
                this.selectOverlay(p)
              })
            })

          }


          this.addButton('Delete selected', () => {
            this.deleteSelection()
          })

          this.addButton('Confirm', () => {
            this.handleComplete()
          })

          // Every time we complete a shape we have to save it to the array
          google.maps.event.addListener(this.item, 'overlaycomplete', this.overlayComplete)
        }

      },
      overlayComplete(e) {
        // Retrieve the shape from the event
        var overlay = e.overlay

        // Store the overlay
        this.overlays.push(overlay)

        // Define click behaviour
        google.maps.event.addListener(overlay, 'click', () => {
          this.selectOverlay(overlay)
        })

        // Disable drawing mode
        this.item.setDrawingMode(null)
      },

      selectOverlay(overlay) {
        this.selectedOverlay = overlay
        overlay.setEditable(true)
      },
      deselectOverlay() {
        this.selectedOverlay.setEditable(false)
        this.selectedOverlay = null
      },
      deleteSelection() {
        if (!this.selectedOverlay) {
          alert('You must select a overlay before editing')
          return
        }
        var index = this.overlays.indexOf(this.selectedOverlay)
        this.overlays.splice(index, 1)
        this.selectedOverlay.setMap(null)
        this.selectedOverlay = null
        this.handleComplete()
      },

      handleComplete() {

        let GeoJSONCollection = {
          type: 'FeatureCollection',
          features: []
        }

        this.overlays.forEach(function (overlay) {
          // Blank GeoJSON template
          let GeoJSON = {
            type: 'Feature',
            properties: {},
            geometry: {
              type: 'Polygon',
              coordinates: [
                []
              ]
            }
          }

          overlay.getPath().getArray().forEach((point) => {
            GeoJSON.geometry.coordinates[0].push([point.lng(), point.lat()])
          })
          // Last item in poly must be equal to last
          GeoJSON.geometry.coordinates[0].push(GeoJSON.geometry.coordinates[0][0])
          GeoJSONCollection.features.push(GeoJSON)
        })

        this.$emit('updated', GeoJSONCollection)
      },
    },
    props: ['initial'],
  }
</script>

<style scoped lang="sass">

</style>



// WEBPACK FOOTER //
// GoogleMapDrawingManager.vue?c00e2c16